import React, {Component} from "react";
import {withTranslate} from 'react-redux-multilingual';

class Maintenance extends Component {


   /* componentDidMount(){
        const title = document.querySelector('.error_title')
        //////// Light //////////
        document.onmousemove = function(e) {
            let x = e.pageX - window.innerWidth/2;
            let y = e.pageY - window.innerHeight/2;

            title.style.setProperty('--x', x + 'px')
            title.style.setProperty('--y', y + 'px')
        }

        ////////////// Shadow ///////////////////
        title.onmousemove = function(e) {
            let x = e.pageX - window.innerWidth/2;
            let y = e.pageY - window.innerHeight/2;

            let rad = Math.atan2(y, x).toFixed(2);
            let length = Math.round(Math.sqrt((Math.pow(x,2))+(Math.pow(y,2)))/10);

            let x_shadow = Math.round(length * Math.cos(rad));
            let y_shadow = Math.round(length * Math.sin(rad));

            title.style.setProperty('--x-shadow', - x_shadow + 'px')
            title.style.setProperty('--y-shadow', - y_shadow + 'px')

        }
    }*/

    render() {
        return (
            <section className="error_section">
                <p className="error_section_subtitle capitalized" style={this.props.language === "ar" ? {letterSpacing : "2px" , fontSize : "25px"} : {} }>{this.props.translate('opps_page_is_not_available') + " " + "!"}</p>
                <h1 className="error_title">500</h1>
                <button onClick={() => {window.location.reload()}} className="btn">{this.props.translate('reload')}</button>
            </section>
        )
    };
}

export default withTranslate(Maintenance);
